// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";

function PazeWallet(props) {
  var logger = props.logger;
  React.useEffect((function () {
          var handle = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            var metaData = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(json), "metadata");
            if (Utils$OrcaPaymentPage.getString(metaData, "wallet", "") !== "Paze") {
              return ;
            }
            var clientId = Utils$OrcaPaymentPage.getString(metaData, "clientId", "");
            var clientName = Utils$OrcaPaymentPage.getString(metaData, "clientName", "");
            var clientProfileId = Utils$OrcaPaymentPage.getString(metaData, "clientProfileId", "");
            var sessionId = Utils$OrcaPaymentPage.getString(metaData, "sessionId", "");
            var publishableKey = Utils$OrcaPaymentPage.getString(metaData, "publishableKey", "");
            var emailAddress = Utils$OrcaPaymentPage.getString(metaData, "emailAddress", "");
            var transactionAmount = Utils$OrcaPaymentPage.getString(metaData, "transactionAmount", "");
            var transactionCurrencyCode = Utils$OrcaPaymentPage.getString(metaData, "transactionCurrencyCode", "");
            var componentName = Utils$OrcaPaymentPage.getString(metaData, "componentName", "");
            var mountPazeSDK = function () {
              var pazeScriptURL = publishableKey.startsWith("pk_snd") ? "https://sandbox.digitalwallet.earlywarning.com/web/resources/js/digitalwallet-sdk.js" : "https://checkout.paze.com/web/resources/js/digitalwallet-sdk.js";
              var loadPazeSDK = async function (param) {
                try {
                  await window.DIGITAL_WALLET_SDK.initialize({
                        client: {
                          id: clientId,
                          name: clientName,
                          profileId: clientProfileId
                        }
                      });
                  var canCheckout = await window.DIGITAL_WALLET_SDK.canCheckout({
                        emailAddress: emailAddress
                      });
                  var transactionValue = {
                    transactionAmount: transactionAmount,
                    transactionCurrencyCode: transactionCurrencyCode
                  };
                  await window.DIGITAL_WALLET_SDK.checkout({
                        acceptedPaymentCardNetworks: [
                          "VISA",
                          "MASTERCARD"
                        ],
                        emailAddress: canCheckout.consumerPresent ? emailAddress : "",
                        sessionId: sessionId,
                        actionCode: "START_FLOW",
                        transactionValue: transactionValue,
                        shippingPreference: "ALL"
                      });
                  var completeObj_transactionOptions = {
                    billingPreference: "ALL",
                    merchantCategoryCode: "US",
                    payloadTypeIndicator: "PAYMENT"
                  };
                  var completeObj = {
                    transactionOptions: completeObj_transactionOptions,
                    transactionId: "",
                    sessionId: sessionId,
                    transactionType: "PURCHASE",
                    transactionValue: transactionValue
                  };
                  var completeResponse = await window.DIGITAL_WALLET_SDK.complete(completeObj);
                  Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                        [
                          "fullscreen",
                          false
                        ],
                        [
                          "isPaze",
                          true
                        ],
                        [
                          "componentName",
                          componentName
                        ],
                        [
                          "completeResponse",
                          Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(completeResponse), "completeResponse", "")
                        ]
                      ]);
                  return Promise.resolve();
                }
                catch (raw_err){
                  var err = Caml_js_exceptions.internalToOCamlException(raw_err);
                  logger.setLogError(JSON.stringify(Utils$OrcaPaymentPage.formatException(err)), "PAZE_SDK_FLOW", undefined, undefined, "ERROR", undefined, "PAZE");
                  Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                        [
                          "fullscreen",
                          false
                        ],
                        [
                          "isPaze",
                          true
                        ],
                        [
                          "flowExited",
                          "stop"
                        ],
                        [
                          "componentName",
                          componentName
                        ]
                      ]);
                  return Promise.resolve();
                }
              };
              logger.setLogInfo("PAZE SDK Script Loading", "PAZE_SDK_FLOW", undefined, undefined, undefined, undefined, undefined);
              var pazeScript = document.createElement("script");
              pazeScript.src = pazeScriptURL;
              pazeScript.onerror = (function (exn) {
                  logger.setLogError("Error During Loading PAZE SDK Script: " + JSON.stringify(exn), "PAZE_SDK_FLOW", undefined, undefined, undefined, undefined, undefined);
                });
              pazeScript.onload = (function () {
                  logger.setLogInfo("PAZE SDK Script Loaded", "PAZE_SDK_FLOW", undefined, undefined, undefined, undefined, undefined);
                  loadPazeSDK();
                });
              document.body.appendChild(pazeScript);
            };
            if ([
                  clientId,
                  clientName,
                  clientProfileId,
                  sessionId,
                  transactionCurrencyCode
                ].every(function (x) {
                    return x !== "";
                  })) {
              return mountPazeSDK();
            }
            
          };
          window.addEventListener("message", handle);
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                  "iframeMountedCallback",
                  true
                ]]);
          return (function () {
                    window.removeEventListener("message", handle);
                  });
        }), []);
  return React.createElement("div", {
              className: "w-full flex flex-row justify-center rounded-md h-auto",
              id: "paze-button"
            });
}

var make = PazeWallet;

export {
  make ,
}
/* react Not a pure module */
